import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import {
  ClearEffectivePermissions,
  SetActivePermissionLocation,
  SetEffectivePermissionsFailure,
  SetEffectivePermissionsLoadStarted,
  SetEffectivePermissionsSuccess,
} from './user-effective-permissions.actions';
import {
  defaultUserEffectivePermissionsState,
  UserEffectivePermissionsStateModel,
} from './user-effective-permissions.model';

@State<UserEffectivePermissionsStateModel>({
  name: 'userEffectivePermissions',
  defaults: defaultUserEffectivePermissionsState,
})
@Injectable()
export class UserEffectivePermissionsState {
  @Action(SetEffectivePermissionsLoadStarted)
  setLoadStarted(ctx: StateContext<UserEffectivePermissionsStateModel>): void {
    ctx.patchState({ loadStarted: true });
  }

  @Action(SetEffectivePermissionsSuccess)
  loadSuccess(
    ctx: StateContext<UserEffectivePermissionsStateModel>,
    action: SetEffectivePermissionsSuccess
  ): void {
    ctx.setState({
      ...ctx.getState(),
      userId: action.userId,
      permissionContexts: action.permissionContexts,
      permissionsResolved: true,
      loadStarted: true,
    });
  }

  @Action(SetEffectivePermissionsFailure)
  loadFailure(
    ctx: StateContext<UserEffectivePermissionsStateModel>,
    action: SetEffectivePermissionsFailure
  ): void {
    ctx.setState({
      ...ctx.getState(),
      userId: action.userId,
      permissionContexts: [],
      permissionsResolved: true,
      loadStarted: true,
    });
  }

  @Action(SetActivePermissionLocation)
  setActiveLocation(
    ctx: StateContext<UserEffectivePermissionsStateModel>,
    action: SetActivePermissionLocation
  ): void {
    ctx.patchState({ activeLocationId: action.locationId });
  }

  @Action(ClearEffectivePermissions)
  clear(ctx: StateContext<UserEffectivePermissionsStateModel>): void {
    ctx.setState(defaultUserEffectivePermissionsState);
  }
}
